import { AxiosResponse } from 'axios';
import { get, post } from '../axiosprovider';
import { EMobileStatus, EFollowUpStatus, EOpportunityFollowUpStatus } from 'models';

const cancelFollowUp = async (id: string, comments: string): Promise<AxiosResponse<void>> => {
	return await post<void>('/api/followup/cancel', { id, comments });
};

const completeFollowUp = async (id: string, comments: string): Promise<AxiosResponse<void>> => {
	return await post<void>('/api/followup/complete', { id, comments });
};

const createFollowUp = async (followUp: ICreateFollowUpRequest): Promise<AxiosResponse<void>> => {
	return await post<void>('/api/followup/create', followUp);
};

const getFollowUpStatus = async (activityId: string): Promise<AxiosResponse<IFollowUpStatusResponse>> => {
	return await get<IFollowUpStatusResponse>(`/api/followup/status/${activityId}`);
};

const updateFollowUpStatus = async (request: IUpdateFollowUpStatusRequest): Promise<AxiosResponse<void>> => {
	return await post<void>('/api/followup/status', request);
};

const updateMobileStatus = async (id: string, mobileStatus: EMobileStatus): Promise<AxiosResponse<void>> => {
	return await post<void>('/api/followup/mobilestatus', { id, mobileStatus });
};

export const followUpsController = {
	cancelFollowUp,
	completeFollowUp,
	createFollowUp,
	getFollowUpStatus,
	updateFollowUpStatus,
	updateMobileStatus
};

export interface ICreateFollowUpRequest {
	appointmentDate: string;
	duration: string;
	mobileStatus: EMobileStatus;
	opportunityId: string;
	ownerId: string;
	specialInstructions: string;
	startTime: string;
	status: EFollowUpStatus;
	subType: string;
	type: string;
}

export interface IFollowUpStatusResponse {
	followUpStatus: EOpportunityFollowUpStatus;
	opportunityId: string;
}

export interface IUpdateFollowUpStatusRequest {
	followUpStatus: EOpportunityFollowUpStatus;
	opportunityId: string;
	followUpCloseReason: string;
	followUpCloseComments: string;
}
